import { resetLoginFlag } from "../rtk/slices/loginSlice/loginSlice";

/**
 * Common logout handler
 * @param {function} dispatch - Redux dispatch function
 * @param {function} navigate - Navigation function from react-router
 */
export const handleLogout = (dispatch, navigate) => {
  console.log("Clearing user data and navigating to login...");
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("crm-user");
  dispatch(resetLoginFlag());
  navigate("/login", { replace: true }); // Verify navigation behavior
  console.log("User navigated to login"); // Check this log
};